var _style, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 63,
    fill: "none",
    viewBox: "0 0 62 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .circle {\n      stroke-dasharray: 1000;\n      stroke-dashoffset: 1000;\n      animation: stroke 1s ease-out forwards;\n    }\n    .mark-star {\n      transform: scale(0);\n      transform-origin: center;\n      animation: zoom-in 300ms ease-out 100ms forwards;\n    }\n    @keyframes stroke {\n      to {\n        stroke-dashoffset: 0;\n      }\n    }\n    @keyframes zoom-in{\n        to{\n            transform: scale(1)\n        }\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#41B661"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 31,
    cy: 31,
    r: 28,
    stroke: "#41B661",
    fill: "none",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "mark-star",
    d: "m47.899 22.436-17.8 17.773-3.626 3.678-3.626-3.652 3.626-3.627 17.8-17.798 3.626 3.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mark-star",
    d: "m30.098 40.21-3.627 3.678-3.626-3.652-8.745-8.72 3.652-3.626 12.346 12.32ZM19.426 17.19l2.572-1.287 1.286-2.572 1.286 2.572 2.572 1.287-2.572 1.286-1.286 2.572-1.286-2.572-2.572-1.286ZM40.002 44.196l1.723-.848.849-1.724.849 1.724 1.723.848-1.723.85-.849 1.723-.849-1.724-1.723-.849Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h62v62H0z",
    transform: "translate(0 .302)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5e386a9f.svg";
export { ForwardRef as ReactComponent };